import { Component, ElementRef, ViewChild } from '@angular/core';
import { Observable, Subject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';

import { FieldBaseComponent } from '../base-component';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-lib-ff-typeahead',
  styleUrls: ['./typeahead.component.scss'],
  templateUrl: './typeahead.component.html',
  imports: [
    FormsModule,
    NgbTypeahead,
    ReactiveFormsModule,
  ],
})
export class FormlyTypeaheadComponent extends FieldBaseComponent {
  public inputModel = null;
  @ViewChild('instance', { static: true }) public instance: NgbTypeahead;
  @ViewChild('typeahead', { static: true }) public control: NgModel;
  @ViewChild('element', { static: true }) public element: ElementRef;
  public focus$ = new Subject<string>();
  public click$ = new Subject<string>();

  public get placeholder(): string {
    return !!this.props.placeholder ? this.props.placeholder : 'Please select or start typing...';
  }

  public formatter = (result: any) => result.label || this.model;

  public search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;
    const options = this.props.options as any;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map((term) =>
        term && !options.find((x) => x.label === term)
          ? options.filter((x) => x.label.toLowerCase().indexOf(term.toLowerCase()) > -1)
          : options,
      ),
    );
  };

  public openTypeahead(): void {
    if (!this.instance.isPopupOpen()) {
      this.element.nativeElement.focus();
    }
  }
}
